import { CartLineProvider, useCart } from "@shopify/hydrogen";
import Button from "~/components/Button/Button";
import CartItem from "~/components/CartItem";
import Text from "~/components/Text";
import {
  CheckoutButton,
  ContentWrapper,
  StyledCartPage,
  SubtotalWrapper,
} from "./CartPage.styles";
import Heading from "~/components/Heading";
import { usePrice } from "~/hooks/usePrice";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { ROUTES } from "~/routes/const";
import { Link } from "@remix-run/react";

const EmptyCart = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <ContentWrapper>
      <Text
        size="label-abc"
        style={{ paddingBottom: theme.space[36], paddingTop: theme.space[16] }}
      >
        {t("Empty")}
      </Text>
      <Link to={ROUTES.SHOP}>
        <Button
          style={{
            marginTop: theme.space[4],
            width: "100%",
          }}
        >
          <Heading hasMotion={false} style={{ fontSize: "14px" }}>
            {t("Shop apparel")}
          </Heading>
        </Button>
      </Link>
    </ContentWrapper>
  );
};

const CartPage = () => {
  const { checkoutUrl, cost, lines } = useCart();
  const { formatPrice } = usePrice();
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <StyledCartPage>
      {lines.length > 0 ? (
        <>
          {lines.map((line) => (
            <CartLineProvider key={line.id} line={line}>
              <CartItem
                id={line.id}
                key={line.id}
                merchandise={line.merchandise}
                quantity={line.quantity}
              />
            </CartLineProvider>
          ))}
          <ContentWrapper>
            <Text size="s" style={{ opacity: "0.5" }} uppercase={false}>
              {t("Including tax and shipping")}
            </Text>
            <SubtotalWrapper>
              <Text size="label-abc">{t("Subtotal")}</Text>
              {cost?.totalAmount.amount && cost.totalAmount.currencyCode && (
                <Heading hasMotion={false} size="h6">
                  {`${cost.totalAmount.currencyCode} ${formatPrice(
                    cost.totalAmount.amount
                  )}`}
                </Heading>
              )}
            </SubtotalWrapper>
            {checkoutUrl && (
              <CheckoutButton href={checkoutUrl}>
                <Button
                  as="span"
                  size="medium"
                  style={{
                    marginBottom: theme.space[16],
                    height: "48px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Heading
                    style={{
                      fontSize: "14px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "start",
                      flexDirection: "row",
                    }}
                    hasMotion={false}
                  >
                    {t("Go to checkout")}
                  </Heading>
                </Button>
              </CheckoutButton>
            )}
            <Link
              to={ROUTES.SHOP}
              style={{
                textAlign: "center",
              }}
            >
              <Heading centered uppercase={true} style={{ fontSize: "14px" }}>
                {t("Shop More")}
              </Heading>
            </Link>
          </ContentWrapper>
        </>
      ) : (
        <EmptyCart />
      )}
    </StyledCartPage>
  );
};

export default CartPage;
